/* eslint-disable jsx-a11y/prefer-tag-over-role */
import { useEffect, useState } from 'react';
import DefaultButton from '../common/default/DefaultButton';
import { getCookie, setCookie } from 'cookies-next';
import parseWithType from '@/utilites/parse-with-type';
import { useSpiritoryModal } from '@/context/SpiritoryModalProvider';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { CommonEnum } from '@/types/translations/CommonEnum';
import cookiesConstants from '../../constants/cookies.constants';

export default function VoucherFestivalFloatingIcon() {
  const modal = useSpiritoryModal();
  const { translate } = useTypedTranslation<CommonEnum>('common');

  const [showFestivalVoucher, setShowFestivalVoucher] = useState(false);

  const handleOpenFestivalModal = () => {
    // base text
    const submitText = translate(CommonEnum['festival.got_it']);
    const welcomeTitle = translate(CommonEnum['festival_v2.welcome_message']);
    const weHope = translate(CommonEnum['festival_v2.event_feedback']);
    const excitementInvite = translate(
      CommonEnum['festival_v2.excitement_invite']
    );
    const exclusiveRewards = translate(CommonEnum['festival.exclusive_reward']);
    const discountInstructions = translate(
      CommonEnum['festival_v2.discount_instructions']
    );
    const urgencyNotice = translate(CommonEnum['festival_v2.urgency_notice']);

    modal.setModalType('info');
    modal.setSubmitText(`${submitText} 🎉`);
    modal.setTitle(welcomeTitle);

    modal.setBody(
      <>
        <div className="tw-px-8 tw-py-6 tw-text-center tw-flex tw-flex-col tw-items-center tw-gap-4">
          <div>
            <p className="tw-text-lg tw-text-gray-700 mb-0">
              <strong className="tw-text-2xl tw-font-bold tw-text-blue-600">
                {weHope}
              </strong>
            </p>
            <div>
              <p className="tw-text-base tw-text-gray-600 mb-0">
                {excitementInvite}
              </p>
              <p className="tw-text-sm tw-text-gray-500 tw-font-medium mb-0">
                {exclusiveRewards}
              </p>
            </div>
          </div>
          <div className="tw-py-2 tw-px-4 tw-bg-gray-100 tw-rounded-md tw-border tw-border-solid tw-border-gray-300">
            <b className="tw-text-xl tw-text-main tw-font-bold">
              {discountInstructions}
            </b>
          </div>
          <p className="tw-text-md tw-text-red-500 tw-font-semibold">
            {urgencyNotice}
          </p>
        </div>
      </>
    );

    modal.openModal();
  };

  useEffect(() => {
    const referralCookie = getCookie(cookiesConstants.COOKIES.REFERRAL_CODE.name);
    const festivalVoucherCookie = getCookie(cookiesConstants.COOKIES.VOUCHER_FESTIVAL.name);
    const voucherFestivalCookie = getCookie(cookiesConstants.COOKIES.VOUCHER_FESTIVAL.name);

    const parsedReferralCookie = parseWithType<{
      code: string;
      valid: boolean;
      type: 'FRIENDS' | 'INFLUENCER' | null;
      showModal: boolean;
    } | null>(referralCookie || 'null');

    const parsedFestivalVoucherCookie = parseWithType<boolean | null>(
      festivalVoucherCookie || 'null'
    );

    const parsedVoucherFestivalCookie = parseWithType<{
      show: boolean;
      code: string;
    } | null>(voucherFestivalCookie);

    if (
      parsedVoucherFestivalCookie !== null &&
      parsedReferralCookie == null &&
      parsedFestivalVoucherCookie == null
    ) {
      setShowFestivalVoucher(true);
    }

    if (
      parsedReferralCookie === null &&
      Boolean(parsedFestivalVoucherCookie) === false &&
      parsedVoucherFestivalCookie?.show === true
    ) {
      setCookie(
        cookiesConstants.COOKIES.VOUCHER_FESTIVAL.name,
        JSON.stringify({
          show: false,
          code: parsedVoucherFestivalCookie.code,
        })
      );

      handleOpenFestivalModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (showFestivalVoucher) {
    return (
      <div className="tw-fixed tw-bottom-4 tw-right-4 tw-z-50">
        <DefaultButton
          className="tw-bg-blue-500 tw-rounded-full tw-shadow-lg tw-p-4 tw-flex tw-items-center tw-justify-center tw-transition tw-transform hover:tw-scale-110 focus:tw-outline-none"
          aria-label="Open Festival Voucher"
          onClick={handleOpenFestivalModal}
        >
          <span role="img" aria-label="Party Popper">
            🎉
          </span>
        </DefaultButton>
      </div>
    );
  }

  return null;
}
